<div class="container-fluid py-4">
  <div class="card">
    <div class="card-header">
      <div class="card-tools">
        <!-- <a
          [routerLink]="['/administracion/users/add']"
          class="btn btn-dark btn-sm btn-new"
        >
          New
        </a> -->
        <a
          [routerLink]="['/administracion/roles']"
          class="btn btn-dark btn-sm btn-new"
        >
          Access Levels
        </a>
      </div>
    </div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Employee Name</th>
              <!--  <th>Last Name</th> -->
              <th>Email</th>
              <th>Role</th>
              <th class="th__status">Status</th>
              <!--  <th>Actions</th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of data">
              <a
                [routerLink]="['/administracion/users/edit', item._id]"
                class="btn btn-link btn-sm p-2 a--user"
              >
                {{ item.firstname }}
                {{ item.lastname }}
              </a>
              <!-- <td>{{ item.firstname }} {{ item.lastname }}</td> -->
              <td>{{ item.username }}</td>
              <td>{{ item.role.name }}</td>
              <td>
                <span
                  class="badge span__badge"
                  [ngClass]="item.status ? 'badge-success' : 'badge-danger'"
                >
                  {{ item.status ? "Active" : "Inactive" }}
                </span>
              </td>
              <!--<td>
                <a
                  [routerLink]="['/administracion/users/edit', item._id]"
                  class="btn btn-link text-dark btn-sm btn-del"
                >
                  <i class="fas fa-edit"></i>
                </a>
                 <button
                  (click)="deleteData(item._id)"
                  class="btn btn-link text-dark btn-sm btn-del"
                >
                  <i class="fas fa-trash"></i>
                </button> 
              </td>-->
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
